const whiteSpaceRegexp = /\s/;
const emailRegexp =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const isNoWhiteSpace = (input: string) => {
  return !whiteSpaceRegexp.test(input);
};

export const isHaveWhiteSpace = (input: string) => {
  return whiteSpaceRegexp.test(input);
};

export const isNotValidEmail = (input: string) => {
  return !input.match(emailRegexp);
};
